import { sharedConfig, syncSharedConfig } from './shared-config';

export const environment = {
  production: true,
  environment: 'development' as const,
  launchDarklyClientId: '6363e7cc09aacd34e3a76bab',
  smartFill: 'https://api-dev.maximizer.com/smartfill/v1/',
  instrumentationKey: '7b177ff5-05e9-4875-bdde-48dd076f9055',
  oauth: {
    globalServicesKey: '',
    globalServicesUrl: 'https://api-dev.maximizer.com/cloud',
    oauth2ClientId: 'vok9tuxpdmmly30hqoi4',
    oauth2ClientIdEmea: '',
    onPremClientId: 'bqdxm6nmvy86w8b7nj85',
  },
  integration: {
    syncApi: 'https://api-stg.maximizer.com/integration/outlook',
    subscriptionKey: 'b4f3e659a0884caaa88b09a0c9c6a1c1',
    webhookUrl: 'https://api-dev.maximizer.com/integrations/test',
  },
  appStoreOAuthUrl:
    'https://appstorestaging.maximizer.com/appstore/midwareolsync2/index',
  appStoreConfigurationUrl:
    'https://appstorestaging.maximizer.com/appstore/midwareolsync2/configurationhandler',
  msalConfig: {
    auth: {
      clientId: '95c881fe-05cc-4b6e-8091-f66e596dd1f9',
      authority: 'https://login.microsoftonline.com/common',
      redirectUri: 'https://dev-outlook365.maxlabcloud.ca',
      postLogoutRedirectUri: '/',
    },
  },
  syncConfig: {
    redirectUri: 'https://dev-outlook365.maxlabcloud.ca/sync-configuration',
    microsoft: {
      tenantId: syncSharedConfig.tenantId,
      clientId: '66b1d3a0-b501-4d3f-9d06-8f44e344fb3a',
      scopes: syncSharedConfig.scopes,
    },
  },
  openAi: 'https://api-stg.maximizer.com/ai/v1',
  integrationApp: {
    webAppUrl: 'https://api-stg.maximizer.com/integration/maximizer-ai',
    iqBoostApiUrl: '/v1',
    subscriptionKey: '',
  },
  ...sharedConfig,
};
